import { render, staticRenderFns } from "./ComponentGraphEditor.vue?vue&type=template&id=3bcb0671&"
import script from "./ComponentGraphEditor.vue?vue&type=script&lang=js&"
export * from "./ComponentGraphEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports